export const appName = "Clique";
